import { useLocation } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

import { DashboardNav } from './dashboard-nav';
import { EntityPageHeader } from './entity-page-header';

export type DashboardLayoutProps = React.ComponentProps<'div'> & {
  topContent?: React.ReactNode;
  type: 'estate' | 'project';
};

export const DashboardLayout = ({
  className,
  children,
  topContent,
  type,
  ...props
}: DashboardLayoutProps) => {
  // Hide the Dashboard Nav for specific routes
  const location = useLocation();
  const currentRoute = location.pathname;
  const hideNavPatterns = [/^\/(estates|projects)\/[^/]+\/media\/edit\/[^/]+$/];
  const hideNav = hideNavPatterns.some((regex) => regex.test(currentRoute));

  return (
    <div className={cn('flex flex-1 flex-col gap-6', className)} {...props}>
      <div className="new-ui flex flex-col gap-6">
        {topContent}
        <EntityPageHeader type={type} />
        {!hideNav && <DashboardNav type={type} />}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};
